var locale = {
  placeholder: 'Sila pilih masa'
};
export default locale;
//# sourceMappingURL=ms_MY.js.map
